import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ProfileSideBar from './components/ProfileSideBar';
import ProfileContent from './components/ProfileContent';
import {
  ProfileData,
  ProfileStateMapping,
  StateToProfileMapping,
  ProfileMessageMapping,
  constructForm2Payload,
  MAX_STEPS,
  KAM_SOURCE,
} from './constants';
import './style.scss';
import {
  getMerchantProfileAction,
  updateMerchantProfileAction,
} from '../../../../redux/actions/completeProfile';
import imgURL from '../../../../lib/imgURL';
import Navbar from '../../../../components/Navbar';
import Button from '../../../../components/Button';
import { UiRoutes } from '../../../../lib/constants';
import useRedirect from '../../../../hooks/useRedirect';
import { isLiveDomain } from 'lib/helper';

const CompleteProfile: FC<any> = (props) => {
  const {
    completeProfileState,
    getMerchantProfileAction,
    updateMerchantProfileAction,
    loginState,
    onboardingSource
  } = props;

  const { push } = useRedirect();

  const [profileStatus, setProfileStatus]: any = useState({});
  const [merchantProfile, setMerchantProfile]: any = useState(ProfileData);
  const [currentStep, setCurrentStep] = useState(
    ProfileStateMapping[profileStatus?.status] || 0
  );
  const nextPage = () => {
    if (currentStep < 6) setCurrentStep(currentStep + 1);
  };

  const prevPage = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  useEffect(() => {
    if(!isLiveDomain() || onboardingSource?.toLowerCase() === KAM_SOURCE || !loginState.leadId) {
      push(UiRoutes.OVERVIEW);
    }
    getMerchantProfileAction();
  }, []);

  useEffect(() => {
    const { isSuccess, isFailure, data } = completeProfileState;
    if (isSuccess && data) {
      try {
        data.profileStatus && setProfileStatus(data.profileStatus);
        data.merchantProfile && setMerchantProfile(data.merchantProfile);
      } catch (e) {
        // no action
      }
    }

    if (isFailure) {
      // notify error
    }
  }, [completeProfileState]);

  const updateProfileDetails = (step, statusData, merchantProfileValue) => {
    const tempProfile = {
      status:
        profileStatus?.saved && profileStatus?.saved[step]
          ? profileStatus?.status
          : StateToProfileMapping[statusData?.completed ? step + 1 : step],
      currentStep: statusData?.completed ? Math.min(MAX_STEPS, step + 1) : step,
      message: ProfileMessageMapping[StateToProfileMapping[step]],
      saved: {
        ...(profileStatus?.saved || {}),
        [step]: statusData?.saved,
      },
      completed: {
        ...(profileStatus?.completed || {}),
        [step]: statusData?.completed,
      },
    };
    const payload = {
      profileStatus: tempProfile,
      merchantProfile: JSON.parse(JSON.stringify(merchantProfileValue)),
    };

    updateMerchantProfileAction(payload);
    setProfileStatus(tempProfile);
    setMerchantProfile(merchantProfileValue);
  };

  const submitForm2 = (merchantProfileValue) => {
    return constructForm2Payload(merchantProfileValue, {
      merchantId: loginState.MerchantId,
      merchantName: loginState.merchantName,
      merchantPan: loginState.merchantPan,
      merchantEmail: loginState.UserEmail,
      leadId: loginState.leadId,
    });
  };

  useEffect(() => {
    if (profileStatus?.status) {
      setCurrentStep(profileStatus?.currentStep || 0);
    }
  }, [profileStatus]);

  useEffect(() => {}, [merchantProfile]);

  return (
    <React.Fragment>
      {merchantProfile?.kycSubmitted &&
      (!merchantProfile?.kycProfile || merchantProfile?.kycReSubmitted) ? (
        <div className='kyc-submitted-container'>
          <Navbar isKycNavBar={true} isKycSubmitted={true} />
          <div className='kyc-submitted-wrapper'>
            <img src={imgURL['kyc-submitted']} alt='kyc submitted' />
            <div className='content-section'>
              <img width={64} src={imgURL.checkCirle} />
              <div className='success-msg'>
                KYC Details submitted successfully!
              </div>
              <div className='review-msg-title'>
                Your Application is under review.
              </div>
              <div className='review-msg-content'>
                We are reviewing your submitted KYC details. We will notify you
                when the review is complete. You can try out our products until
                then
              </div>
              <Button
                btnStyleClass='back-dashboard'
                label='Continue to dashboard'
                onClick={() => {
                  push(UiRoutes.OVERVIEW);
                }}
                enable
              />
            </div>
          </div>
        </div>
      ) : (
        <div className='profile-container'>
          <ProfileSideBar
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            profileStatus={profileStatus}
          />
          <ProfileContent
            nextPage={nextPage}
            prevPage={prevPage}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            updateProfileDetails={updateProfileDetails}
            merchantProfile={merchantProfile}
            setMerchantProfile={setMerchantProfile}
            submitForm2={submitForm2}
          />
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = ({ completeProfileReducer, loginReducer }) => ({
  completeProfileState: completeProfileReducer?.completeProfileState,
  updateProfileState: completeProfileReducer?.updateProfileState,
  loginState: loginReducer?.loginState,
  onboardingSource: loginReducer?.loginState?.onboardingSource,
});

export default connect(mapStateToProps, {
  getMerchantProfileAction,
  updateMerchantProfileAction,
})(CompleteProfile);
